// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  segmentId: __t.u64().primaryKey().name("segment_id"),
  regionId: __t.u64().name("region_id"),
  treeId: __t.u64().name("tree_id"),
  parentSegmentId: __t.u64().name("parent_segment_id"),
  attachS: __t.f64().name("attach_s"),
  attachTheta: __t.f64().name("attach_theta"),
  p0X: __t.f64().name("p_0_x"),
  p0Y: __t.f64().name("p_0_y"),
  p0Z: __t.f64().name("p_0_z"),
  p1X: __t.f64().name("p_1_x"),
  p1Y: __t.f64().name("p_1_y"),
  p1Z: __t.f64().name("p_1_z"),
  p2X: __t.f64().name("p_2_x"),
  p2Y: __t.f64().name("p_2_y"),
  p2Z: __t.f64().name("p_2_z"),
  p3X: __t.f64().name("p_3_x"),
  p3Y: __t.f64().name("p_3_y"),
  p3Z: __t.f64().name("p_3_z"),
  length: __t.f64(),
  radiusBase: __t.f64().name("radius_base"),
  radiusTip: __t.f64().name("radius_tip"),
});
